import { useMediaQueryScales, SizeMediaScales } from './media-query';
export function useDisplayMediaQuery(props) {
    var scales = useMediaQueryScales(props.useMediaQuery);
    for (var _i = 0, SizeMediaScales_1 = SizeMediaScales; _i < SizeMediaScales_1.length; _i++) {
        var scale = SizeMediaScales_1[_i];
        if (props["".concat(scale, "Show")] === false || props["".concat(scale, "Hidden")] === true) {
            if (scales[scale])
                props.hidden = true;
        }
    }
}
